@if (filters?.length) {
    <ui-button size="mobile-shrink" type="ghost" [matMenu]="menu"
        ><mat-icon class="filter-icon" [svgIcon]="hasActiveFilters() ? 'filterFilled' : 'filter'"></mat-icon
        >{{ 'filters' | appTranslate }}
    </ui-button>
}

<mat-menu class="multi-filter-menu-content" #menu="matMenu">
    <mat-accordion multi displayMode="flat">
        @if (areFiltersReady) {
            <!--$event.stopPropagation() ensures the menu doesn't auto-dismiss upon clicking, which would lead to a frustrating user experience-->
            @for (filter of filters; track filter.label) {
                <mat-expansion-panel (click)="$event.stopPropagation()">
                    <!--Collapsed and expanded heights are equivalent constant values set within the component-->
                    <mat-expansion-panel-header collapsedHeight="{{ ROW_HEIGHT }}" expandedHeight="{{ ROW_HEIGHT }}"
                        >{{ filter.label | appTranslate }}
                        @if (getActiveFilterString(filter)) {
                            <span class="counter">{{ getActiveFilterString(filter) }}</span>
                        }
                    </mat-expansion-panel-header>
                    <ng-template matExpansionPanelContent>
                        <app-table-column-filter [filter]="filter" />
                    </ng-template>
                </mat-expansion-panel>
            }
        }
    </mat-accordion>
</mat-menu>
